export default __webpack_public_path__ + "static/Tek_Surveillance_Console-834481f35900605fcacb1de198a13286.png";